import Ezaxios from "@/ezaxios";
import store from '@/store';

export default {
  getProduct(param) {
    return Ezaxios.get(`products/product?param=${param}`);
  },
  getProductBySlug(slug) {
    return Ezaxios.get(`products/product?param=${slug}&field=slug`);
  },
  getSimiliarProducts(upc) {
    return Ezaxios.get(`products/${upc}/addons`);
  },
  getPopularProducts() {
    return Ezaxios.get(`popular-products?date=2019-02-04`); // delete this, temporaly (API not working properly)
  },
  getVideos(upc) {
    return Ezaxios.get(`products/${upc}/videos`);
  },
  getFavouriteProducts(admin = false) {
    return Ezaxios.get(`favourite-products${ admin ? '?view_as_admin=true' : '' }`);
  },
  getRandomProducts(o) {
    let q = '';
    if(o.brand_id)
      q += `&brands[]=${o.brand_id}`;
    if(o.dept_id)
      q += `&dept_id=${o.dept_id}`;
    return Ezaxios.get(`products?search=%27%27${q}&limit=${o.limit}&sort=relevancy&page=1&in_stock_only=1&randomize=1`);
  },
  getRandomProductsByStoreId(o,StoreId) {
    let q = '';
    if(o.brand_id)
      q += `&brands[]=${o.brand_id}`;
    if(o.dept_id)
      q += `&dept_id=${o.dept_id}`;

    return Ezaxios.get(`products?search=%27%27${q}&limit=${o.limit}&sort=relevancy&page=1&in_stock_only=1&randomize=1`, {
      headers: {'Store-Id': StoreId}
    });
  },
  getTopProductsOfBrand(brandId, sku) {
    return Ezaxios.get(`top-selling/${brandId}/${sku}`);
  },
  getPartnerProductInventoryBySku(sku){
    return Ezaxios.get(`partner-business-product-inventory/${sku}`);
  },
  getProductLogs(data) {
    return Ezaxios.post(`admin/product/logs`, data, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token') || sessionStorage.getItem('token')}`,
        'Business-Slug': store.state.business_slug
      }
    });
  },
  getWidgetProducts(data) {
    return Ezaxios.post(`widget/getProducts`, data, {
      headers: {
        'Business-Slug': store.state.business_slug
      }
    });
  },
  getRecentViewedItems() {
    return Ezaxios.post(`products/get-recent`, { device_id: store.state.device_id }, {
      headers: {
        'Business-Slug': store.state.business_slug
      }
    });
  },
  getRecentViewedProductsData(data) {
    return Ezaxios.post(`widget/get-recent-viewed-products-data`, data, {
      headers: {
        'Business-Slug': store.state.business_slug
      }
    });
  },
  saveItemBackInStockNotificationDetails(data) {
    return Ezaxios.post(`products/save-back-in-stock-details`, data, {
      headers: {
        'Business-Slug': store.state.business_slug
      }
    });
  }
};
